import { Instagram } from 'lucide-react';
import { SITE } from '@/config/site';

export default function Footer() {
  return (
    <footer className="border-t border-white/5 px-5 py-10 sm:px-10">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-5 sm:flex-row">
        <p className="text-[10px] uppercase tracking-[0.4em] text-cream/80">
          Cristian Cruz<span className="text-gold">.</span>
        </p>
        <a
          data-testid="footer-instagram"
          href={SITE.instagram}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-cream/50 transition-colors duration-300 hover:text-gold"
        >
          <Instagram size={13} /> {SITE.instagramHandle}
        </a>
        <p className="text-[10px] tracking-wider text-cream/30">© {new Date().getFullYear()} — Todos los derechos reservados</p>
      </div>
    </footer>
  );
}
